import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Tabs from './Tabs';
import entityMktSettingsService from '../../services/partnerMktSettingsService';

// WHERE THIS CREDENTIAL IS USED — the Usage tab of the shared credential editor (CredentialsTab's CredentialModal):
// one sub-tab per product (Sync, Pipelines, Universal API, Payment Porter, Payment Migration Manager, Vault, Dryft, DVM
// Extractor, Opera Cloud Compare) with how many of each, and the projects themselves — name (to its own screen), how it
// uses the credential, its status and its property. Read from GET /partnermktsettings/usage, which answers each product
// separately, so one that cannot be read says so without blanking the rest.

const when = (v) => (v ? new Date(v).toLocaleDateString() : '—');

export default function CredentialUsage({ credentialId }) {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [active, setActive] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setData(null); setError(null);
        entityMktSettingsService.getUsage(credentialId)
            .then(d => {
                if (cancelled) return;
                setData(d);
                // Open on the first product that uses it, else the first.
                const first = (d.products || []).find(p => p.items.length) || (d.products || [])[0];
                setActive(first ? first.key : null);
            })
            .catch(e => { if (!cancelled) setError(e.response?.data?.error?.message || e.message); });
        return () => { cancelled = true; };
    }, [credentialId]);

    if (error) return <div style={{ padding: '10px 14px', background: '#fee2e2', color: '#dc2626', borderRadius: 6, fontSize: 13 }}>{error}</div>;
    if (!data) return <p style={{ fontSize: 13, color: '#64748b' }}>Loading…</p>;

    const product = (data.products || []).find(p => p.key === active);
    return (
        <div>
            <p style={{ margin: '0 0 0.75rem', fontSize: 13, color: '#64748b' }}>
                {data.total
                    ? `Used ${data.total} time${data.total === 1 ? '' : 's'}. Changing this credential changes every one of these; deleting it breaks them.`
                    : 'Not used by any project yet.'}
            </p>
            <Tabs
                size="sm"
                tabs={(data.products || []).map(p => ({ key: p.key, label: p.label, count: p.items.length }))}
                active={active}
                onChange={setActive}
            />
            {product && (
                product.error ? (
                    <div style={{ padding: '10px 14px', background: '#fef3c7', color: '#92400e', borderRadius: 6, fontSize: 13, marginTop: 12 }}>
                        {product.label}: {product.error}
                    </div>
                ) : product.items.length === 0 ? (
                    <p style={{ fontSize: 13, color: '#94a3b8', marginTop: 12 }}>No {product.label} projects use this credential.</p>
                ) : (
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginTop: 12 }}>
                        <thead>
                            <tr style={{ textAlign: 'left', color: '#64748b' }}>
                                <th style={{ padding: '6px 8px', fontWeight: 600 }}>Project</th>
                                <th style={{ padding: '6px 8px', fontWeight: 600 }}>Used as</th>
                                <th style={{ padding: '6px 8px', fontWeight: 600 }}>Property</th>
                                <th style={{ padding: '6px 8px', fontWeight: 600 }}>Status</th>
                                <th style={{ padding: '6px 8px', fontWeight: 600 }}>Updated</th>
                            </tr>
                        </thead>
                        <tbody>
                            {product.items.map(it => (
                                <tr key={it.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '6px 8px' }}><Link to={it.link} target="_blank" rel="noopener noreferrer">{it.name}</Link></td>
                                    <td style={{ padding: '6px 8px', color: '#475569' }}>{it.role || '—'}</td>
                                    <td style={{ padding: '6px 8px' }}>{it.hotel || '—'}{it.chain && <div style={{ fontSize: 12, color: '#94a3b8' }}>{it.chain}</div>}</td>
                                    <td style={{ padding: '6px 8px', color: '#475569' }}>{it.status || '—'}</td>
                                    <td style={{ padding: '6px 8px', color: '#94a3b8', whiteSpace: 'nowrap' }}>{when(it.updated)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )
            )}
        </div>
    );
}
